import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../apiconfig";
import logoutUser from "./logoutUser";


function Address({ onNext, onPrev }) {

	const navigate = useNavigate();
	const [alertData, setAlertData] = useState(null);
	const showAlert = (message, type = "error") => {
		setAlertData({
			message,
			type,
			id: Date.now()
		});

		setTimeout(() => {
			setAlertData(null);
		}, 5000);
	};

	const [addressData, setAddressData] = useState({
		address1: "",
		address2: "",
		address3: "",
		city: "",
		pincode: "",
		district: "",
		state: "",
		stdcode: "",
		telno: ""
	});


	const handleChange = (e) => {
		const { name, value } = e.target;

		setAddressData({
			...addressData,
			[name]: value
		});
	};

	const [userInfo, setUserInfo] = useState({
		appNo: "",
		email: "",
		mobileNo: ""
	});

	useEffect(() => {
		const fetchData = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const res = await fetch(
					`${API_BASE_URL}/API/Student/GET_UNIQUE_DATA`,
					{
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				const data = await res.json();
				console.log("address info unique data", data);

				setUserInfo(data);

			} catch (err) {
				console.error(err);
			}
		};

		fetchData();
	}, []);

	const fetchAddressData = async () => {
		try {
			const token = sessionStorage.getItem("token");

			const res = await fetch(
				`${API_BASE_URL}/API/Student/GET_ADDRESS_INFO`,
				{
					method: "GET",
					headers: {
						"Authorization": "Bearer " + token
					}
				}
			);

			if (res.status === 401 || res.status === 403) {

				logoutUser(navigate);
				return;
			}

			if (!res.ok) {
				console.error("Failed to fetch program");
				return;
			}

			const data = await res.json();
			console.log("address details is:", data);

			if (res.ok && data !== "NOT_FOUND") {
				setAddressData({
					address1: data.address1 || "",
					address2: data.address2 || "",
					address3: data.address3 || "",
					city: data.city || "",
					pincode: data.pincode || "",
					district: data.district || "",
					state: data.state || "",
					stdcode: data.stdcode || "",
					telno: data.telno || ""
				});
			}

		} catch (err) {
			console.error("Fetch error:", err);
		}
	};

	useEffect(() => {
		fetchAddressData();
	}, []);

	const validateAddressData = () => {

		if (!addressData.address1?.trim()) {
			showAlert("Address Line 1 is required ❗");
			return false;
		}

		if (!addressData.address2?.trim()) {
			showAlert("Address Line 2 is required ❗");
			return false;
		}

		if (!addressData.city?.trim()) {
			showAlert("City is required ❗");
			return false;
		}

		if (!addressData.pincode?.trim()) {
			showAlert("Pin Code is required ❗");
			return false;
		}

		if (!addressData.district?.trim()) {
			showAlert("District is required ❗");
			return false;
		}

		// ✅ PINCODE format (6 digits)
		if (!/^[0-9]{6}$/.test(addressData.pincode)) {
			showAlert("Enter valid 6-digit Pin Code ❗");
			return false;
		}

		if (!addressData.state?.trim()) {
			showAlert("State is required ❗");
			return false;
		}


		if (!addressData.stdcode?.trim()) {
			showAlert("Std.code is required ❗");
			return false;
		}

		if (!addressData.telno?.trim()) {
			showAlert("Tel.No. is required ❗");
			return false;
		}



		return true; // ✅ all good
	};

	const handleAddressNext = async () => {

		if (!validateAddressData()) return;
		console.log("handleAddressNext");
		try {
			const token = sessionStorage.getItem("token");

			const response = await fetch(
				`${API_BASE_URL}/API/Student/SAVE_ADDRESS`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer " + token
					},
					body: JSON.stringify(addressData)
				}
			);

			if (response.status === 401) {
				sessionStorage.clear();
				showAlert("Session expired ❗ Please login again", "error");

				setTimeout(() => {
					window.location.href = "/ASTU_JMEE_JLEE/Login";
				}, 1000);
				return;
			}

			const result = await response.text();

			if (!response.ok) throw new Error(result);

			if (result === "SAVED") {
				showAlert("Address saved ✅", "success");

				setTimeout(() => {
					onNext();
				}, 600);
			}

			if (result === "PROGRAM_SELECTION_INCOMPLETE") {
				showAlert("Please select program first ❗", "error");
			}

		} catch (err) {
			console.error(err);
			showAlert("Error saving address ❗", "error");
		}
	};

	const [isPaymentDone, setIsPaymentDone] = useState(false);

	useEffect(() => {
		const checkPaymentStatus = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PAYMENT_DONE_OR_NOT`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const result = await response.json(); // boolean true/false
				console.log("Payment Done:", result);

				setIsPaymentDone(result);



			} catch (error) {
				console.error("Error checking payment:", error);
			}
		};

		checkPaymentStatus();
	}, []);

	const [isEditOn, setIsEditOn] = useState(false);
			useEffect(() => {
					const checkPaymentStatus = async () => {
						try {
							const token = sessionStorage.getItem("token");

							const response = await fetch(
								`${API_BASE_URL}/API/Student/EDIT_ON_OFF`,
								{
									method: "GET",
									headers: {
										"Authorization": "Bearer " + token
									}
								}
							);

							if (!response.ok) return;

							const result = await response.json(); 
							console.log("edit response:", result);

							setIsEditOn(result);



						} catch (error) {
							console.error("Error checking payment:", error);
						}
					};

					checkPaymentStatus();
				}, []);
				
				//const canEdit = !isPaymentDone || isEditOn === false;
				const canEdit = isEditOn === false;


	return (
		<div>

			<style>{`

				@keyframes smoothEntry {
				0% {
				    opacity: 0;
				    transform: translateY(20px);
	    		  }
			  100% {
				    opacity: 1;
				    transform: translateY(0);
			  }
			}
        .container {
          width: 100%;
          max-width: 900px;
          margin: 15px auto;
          background: #fff;
          padding: 16px 18px;
          border-radius: 10px;
          border: 1px solid #e2e8f0;
		  animation: smoothEntry 0.4s ease;
        }

        /* TOP TITLE */
        .title {
          font-size: 16px;
          font-weight: 600;
          color: #065f46;
          margin-bottom: 12px;
        }

        /* MAIN ROW */
        .main-row {
          display: flex;
          align-items: flex-start;
          gap: 20px;
		  margin-bottom: 12px; 
		  
        }

        /* LEFT LABEL */
        .left-label {
          width: 230px;
          font-size: 13.5px;
          font-weight: 500;
          color: #111827;
          padding-top: 6px;
        }

        /* RIGHT SIDE */
        .right-fields {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .field {
          position: relative;
        }

        /* 🔥 SMALL INPUT */
        .field input {
          width: 80%;
          height: 22px;          
          padding: 8px 10px 2px; 
          font-size: 12.5px;
          border: 1px solid #cbd5e1;
          border-radius: 5px;
          outline: none;
        }

        .field label {
          position: absolute;
          left: 10px;
          top: 8px;
          font-size: 12px;
          color: #64748b;
          background: #fff;
          padding: 0 4px;
          transition: 0.15s ease;
        }

        .field input:focus + label,
        .field input:not(:placeholder-shown) + label {
          top: -6px;
          font-size: 10px;
          color: #059669;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .main-row {
            flex-direction: column;
          }

          .left-label {
            width: 100%;
          }
        }

		.small-row {
		  display: flex;
		  gap: 12px;
		}

		.half {
		  flex: 0 0 220px;   /* 🔥 fixed small width */
		}
		.simple-field input {
		  width: 220px;      /* 🔥 small width */
		  height: 18px;
		  padding: 4px 8px;
		  font-size: 12.5px;
		  border: 1px solid #cbd5e1;
		  border-radius: 5px;
		  outline: none;
		}
		/* BUTTONS ALIGN */
				.footer {
				  display: flex;
				  justify-content: space-between;
				  margin-top: 16px;
				}

				.btn {
				  padding: 6px 14px;
				  font-size: 13px;
				  border-radius: 6px;
				  border: none;
				  cursor: pointer;
				}

				.prev {
				  background: #e2e8f0;
				}

				.next {
				  background: #059669;
				  color: #fff;
				}
      `}</style>

			{alertData && (
				<div className={`custom-alert ${alertData.type}`}>
					<span className="alert-icon">
						{alertData.type === "success" ? "✔" : "❗"}
					</span>
					{alertData.message}
				</div>
			)}

			<div className="container">

				{/* TOP TITLE */}
				<div className="title">
					Address for Communication :
				</div>

				<div className="main-row">

					{/* LEFT LABEL AGAIN */}
					<div className="left-label">
						Address for Communication :
					</div>

					{/* RIGHT FIELDS */}
					<div className="right-fields">

						<div className="field">
							<input
								name="address1"
								value={addressData.address1}
								onChange={handleChange}
								placeholder=" "
								autoComplete="new-password"
								disabled={!canEdit}
							/>
							<label>Address Line 1 *</label>
						</div>

						<div className="field">
							<input
								name="address2"
								value={addressData.address2}
								onChange={handleChange}
								placeholder=" "
								autoComplete="new-password"
								disabled={!canEdit}
							/>
							<label>Address Line 2 *</label>
						</div>

						<div className="field">
							<input
								name="address3"
								value={addressData.address3}
								onChange={handleChange}
								placeholder=" "
								autoComplete="new-password"
								disabled={!canEdit}
							/>
							<label>Address Line 3</label>
						</div>


					</div>


				</div>

				<div className="main-row">

					<div className="left-label">
						City :
					</div>

					<div className="right-fields">

						<div className="simple-field">
							<input
								name="city"
								value={addressData.city || ""}
								onChange={handleChange}
								placeholder=""
								maxLength={15}
								autoComplete="new-password"
								disabled={!canEdit}
							/>
						</div>

					</div>



				</div>

				<div className="main-row">

					<div className="left-label">
						Pin Code :
					</div>

					<div className="right-fields">

						<div className="simple-field">
							<input
								name="pincode"
								value={addressData.pincode || ""}
								onChange={handleChange}
								placeholder=""
								maxLength={6}
								autoComplete="new-password"
								disabled={!canEdit}
							/>
						</div>

					</div>



				</div>

				<div className="main-row">

					<div className="left-label">
						District  :
					</div>

					<div className="right-fields">

						<div className="simple-field">
							<input
								name="district"
								value={addressData.district || ""}
								onChange={handleChange}
								placeholder=""
								maxLength={28}
								autoComplete="new-password"
								disabled={!canEdit}
							/>
						</div>

					</div>



				</div>

				<div className="main-row">

					<div className="left-label">
						State :
					</div>

					<div className="right-fields">

						<div className="simple-field">
							<input
								name="state"
								value={addressData.state || ""}
								onChange={handleChange}
								placeholder=""
								maxLength={28}
								autoComplete="new-password"
								disabled={!canEdit}
							/>
						</div>

					</div>



				</div>

				<div className="main-row">

					<div className="left-label">
						STD Code :
					</div>

					<div className="right-fields">

						<div className="simple-field">
							<input
								name="stdcode"
								value={addressData.stdcode || ""}
								type="text"
								onChange={(e) => {
									const value = e.target.value.replace(/[^0-9-]/g, ""); // ✅ allow digits + -
									setAddressData({
										...addressData,
										stdcode: value
									});
								}}
								onKeyPress={(e) => {
									if (!/[0-9-]/.test(e.key)) {
										e.preventDefault();
									}
								}}
								placeholder="e.g. 022-"
								maxLength={6}
								autoComplete="new-password"
								disabled={!canEdit}
							/>
						</div>

					</div>



				</div>

				<div className="main-row">

					<div className="left-label">
						Tel. No. :
					</div>

					<div className="right-fields">

						<div className="simple-field">
							<input
								name="telno"
								value={addressData.telno || ""}
								type="text"
								onChange={(e) => {
									const value = e.target.value.replace(/[^0-9-]/g, ""); // ✅ allow digits + -
									setAddressData({
										...addressData,
										telno: value
									});
								}}
								onKeyPress={(e) => {
									if (!/[0-9-]/.test(e.key)) {
										e.preventDefault();
									}
								}}
								maxLength={13}
								autoComplete="new-password"
								placeholder="e.g. 12345678"
								disabled={!canEdit}
							/>
						</div>

					</div>



				</div>

				<div className="main-row">

					<div className="left-label">
						Mobile Number :
					</div>

					<div className="right-fields">

						<div className="simple-field">
							<input
								name="mobileNo"
								value={userInfo.mobileNo || ""}
								readOnly
								style={{
									filter: "blur(0.2px)",
									opacity: 0.7,
									backgroundColor: "#f5f5f5",
									cursor: "not-allowed"
								}}
							/>
						</div>

					</div>



				</div>

				<div className="main-row">

					<div className="left-label">
						E-Mail :
					</div>

					<div className="right-fields">

						<div className="simple-field">
							<input
								name="email"
								value={userInfo.email || ""}
								readOnly
								style={{
									filter: "blur(0.2px)",
									opacity: 0.7,
									backgroundColor: "#f5f5f5",
									cursor: "not-allowed"
								}}
							/>
						</div>

					</div>



				</div>

				<div className="footer">
					<button className="btn prev" onClick={onPrev}>
						← Previous
					</button>
					<button className="btn next" onClick={handleAddressNext}>Next →</button>
				</div>

			</div>


		</div>

	);
}

export default Address;